<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister">
            New Price Model
            <v-icon right>add_circle</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-text-field
                name="name"
                label="Price Model name"
                type="text"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="statusList"
                label="Choose Status ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="priceModelList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.description }}</td>
              <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
              <td>{{ props.item.updatedBy }}</td>
              <td>
                <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { priceModelService } from "../../services/price-model-service";
export default {
  name: "PriceModelList",

  components: {},
  data: () => ({
    showListLoading: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true
      },
      {
        text: "Price Model",
        disabled: true
      }
    ],
    headers: [
      { text: "Name", align: "left", value: "name" },
      { text: "Status", value: "status" },
      { text: "Description", value: "description" },
      { text: "Updated  Date", value: "updatedDate" },
      { text: "Updated  By", value: "updatedBy" },
      { text: "Action", value: "name", sortable: false }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0
    },
    statusList: [
      { label: "----All----", value: "" },
      { label: "ACTIVE", value: "ACTIVE" },
      { label: "INACTIVE", value: "INACTIVE" }
    ],
    priceModelList: [],
    totalRows: 0,
    queryParams: {
      name: "",
      status: ""
    }
  }),
  watch: {
    pagination: {
      handler() {
        this.getPriceModelList();
      },
      deep: true
    }
  },
  created() {
    //for deep linking
    if (this.$route.query.name) {
      this.queryParams.name = this.$route.query.name;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    this.getPriceModelList();
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "price-models", query: this.queryParams });
      this.getPriceModelList();
    },

    getPriceModelList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      priceModelService
        .getPriceModelList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.priceModelList = res.data.data;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    onRegister() {
      this.$router.push("/price-model/new");
    },
    onEdit(data) {
      // go to details page
      this.$router.push("/price-model/" + data.id);
    }
  }
};
</script>